import meter1 from "../assets/img/meter1.svg";
import meter2 from "../assets/img/meter2.svg";
import meter3 from "../assets/img/meter3.svg";
import html from "../assets/img/htmll.png";
import css from "../assets/img/csss.png";
import js from "../assets/img/js.png";
import db from "../assets/img/db.webp";
import react from "../assets/img/react.png";
import nest from "../assets/img/nestt.png";
import next from "../assets/img/next.png";
import mui from "../assets/img/muii.png";
import bs from "../assets/img/bs.png";
import firebase from "../assets/img/firebase.png";
import node from "../assets/img/node.png";
import redux from "../assets/img/redux.png";
import ts from "../assets/img/ts.png";
import pm from "../assets/img/pm.png";
import gql from "../assets/img/gql.png";
import android from "../assets/img/android.png";
import ant from "../assets/img/ant.png";
import git from "../assets/img/git.png";
import api from "../assets/img/apii.png";
import jquery from "../assets/img/jquery1.webp";
import tw from "../assets/img/tw.png";
import mysql from "../assets/img/mysql.png";
import jira from "../assets/img/jira.png";
import ios from "../assets/img/ios.webp";
import py from "../assets/img/py.webp";

import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import arrow1 from "../assets/img/arrow1.svg";
import arrow2 from "../assets/img/arrow2.svg";
import colorSharp from "../assets/img/color-sharp.png";

export const Skills = () => {
  return (
    <section className="skill" id="skills">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="skill-bx wow zoomIn">
              <h2>Skills</h2>
              <div className="row">
                {/* HTML */}
                <div className="col-lg-2 col-md-3 col-sm-4 col-6">
                  <div className="item">
                    <img
                      src={html}
                      alt="HTML Skill"
                      loading="lazy"
                      decoding="async"
                      style={{
                        width: "30%",
                        height: "30%",
                        marginBottom: 10,
                        marginTop: 20,
                      }}
                      className="icon"
                    />
                    <h6>HTML </h6>
                  </div>
                </div>
                {/* CSS */}
                <div className="col-lg-2 col-md-3 col-sm-4 col-6">
                  <div className="item">
                    <img
                      className="icon"
                      src={css}
                      alt="CSS Skill"
                      loading="lazy"
                      decoding="async"
                      style={{
                        width: "30%",
                        height: "30%",
                        marginBottom: 10,
                        marginTop: 20,
                      }}
                    />
                    <h6>CSS </h6>
                  </div>
                </div>
                {/* JS */}
                <div className="col-lg-2 col-md-3 col-sm-4 col-6">
                  <div className="item">
                    <img
                      className="icon"
                      src={js}
                      alt="JavaScript Skill"
                      loading="lazy"
                      decoding="async"
                      style={{
                        width: "30%",
                        height: "30%",
                        marginBottom: 10,
                        marginTop: 20,
                      }}
                    />
                    <h6>Javascript </h6>
                  </div>
                </div>
                {/* React */}
                <div className="col-lg-2 col-md-3 col-sm-4 col-6">
                  <div className="item">
                    <img
                      className="icon"
                      src={react}
                      alt="React Skill"
                      loading="lazy"
                      decoding="async"
                      style={{
                        width: "30%",
                        height: "30%",
                        marginBottom: 10,
                        marginTop: 20,
                      }}
                    />
                    <h6>React js </h6>
                  </div>
                </div>
                {/* jQuery */}
                <div className="col-lg-2 col-md-3 col-sm-4 col-6">
                  <div className="item">
                    <img
                      className="icon"
                      src={jquery}
                      alt="jQuery Skill"
                      loading="lazy"
                      decoding="async"
                      style={{
                        width: "30%",
                        height: "30%",
                        marginBottom: 10,
                        marginTop: 20,
                      }}
                    />
                    <h6>JQuery </h6>
                  </div>
                </div>
                {/* Tailwind */}
                <div className="col-lg-2 col-md-3 col-sm-4 col-6">
                  <div className="item">
                    <img
                      className="icon"
                      src={tw}
                      alt="Tailwind Skill"
                      loading="lazy"
                      decoding="async"
                      style={{
                        width: "30%",
                        height: "30%",
                        marginBottom: 20,
                        marginTop: 30,
                      }}
                    />
                    <h6>Tailwind </h6>
                  </div>
                </div>
                {/* Bootstrap */}
                <div className="col-lg-2 col-md-3 col-sm-4 col-6">
                  <div className="item">
                    <img
                      className="icon"
                      src={bs}
                      alt="Bootstrap Skill"
                      loading="lazy"
                      decoding="async"
                      style={{
                        width: "30%",
                        height: "30%",
                        marginBottom: 10,
                        marginTop: 30,
                      }}
                    />
                    <h6>Bootstrap </h6>
                  </div>
                </div>
                {/* Material UI */}
                <div className="col-lg-2 col-md-3 col-sm-4 col-6">
                  <div className="item">
                    <img
                      className="icon"
                      src={mui}
                      alt="Material UI Skill"
                      loading="lazy"
                      decoding="async"
                      style={{
                        width: "30%",
                        height: "30%",
                        marginBottom: 10,
                        marginTop: 30,
                      }}
                    />
                    <h6>Material UI </h6>
                  </div>
                </div>
                {/* MongoDB */}
                <div className="col-lg-2 col-md-3 col-sm-4 col-6">
                  <div className="item">
                    <img
                      className="icon"
                      src={db}
                      alt="MongoDB Skill"
                      loading="lazy"
                      decoding="async"
                      style={{
                        width: "30%",
                        height: "30%",
                        marginBottom: 10,
                        marginTop: 20,
                      }}
                    />
                    <h6>MongoDB </h6>
                  </div>
                </div>
                {/* Ant Design */}
                <div className="col-lg-2 col-md-3 col-sm-4 col-6">
                  <div className="item">
                    <img
                      className="icon"
                      src={ant}
                      alt="Ant Design Skill"
                      loading="lazy"
                      decoding="async"
                      style={{
                        width: "30%",
                        height: "30%",
                        marginBottom: 10,
                        marginTop: 20,
                      }}
                    />
                    <h6>Ant Design </h6>
                  </div>
                </div>
                {/* MySQL */}
                <div className="col-lg-2 col-md-3 col-sm-4 col-6">
                  <div className="item">
                    <img
                      className="icon"
                      src={mysql}
                      alt="MySQL Skill"
                      loading="lazy"
                      decoding="async"
                      style={{
                        width: "40%",
                        height: "40%",
                        marginBottom: 2,
                        marginTop: 10,
                      }}
                    />
                    <h6>MySQL </h6>
                  </div>
                </div>
                {/* Redux */}
                <div className="col-lg-2 col-md-3 col-sm-4 col-6">
                  <div className="item">
                    <img
                      className="icon"
                      src={redux}
                      alt="Redux Skill"
                      loading="lazy"
                      decoding="async"
                      style={{
                        width: "30%",
                        height: "30%",
                        marginBottom: 10,
                        marginTop: 20,
                      }}
                    />
                    <h6>Redux </h6>
                  </div>
                </div>
                {/* GraphQL */}
                <div className="col-lg-2 col-md-3 col-sm-4 col-6">
                  <div className="item">
                    <img
                      className="icon"
                      src={gql}
                      alt="GraphQL Skill"
                      loading="lazy"
                      decoding="async"
                      style={{
                        width: "30%",
                        height: "30%",
                        marginBottom: 10,
                        marginTop: 20,
                      }}
                    />
                    <h6>GraphQL </h6>
                  </div>
                </div>
                {/* TypeScript */}
                <div className="col-lg-2 col-md-3 col-sm-4 col-6">
                  <div className="item">
                    <img
                      className="icon"
                      src={ts}
                      alt="TypeScript Skill"
                      loading="lazy"
                      decoding="async"
                      style={{
                        width: "25%",
                        height: "25%",
                        marginBottom: 10,
                        marginTop: 20,
                      }}
                    />
                    <h6>Typescript </h6>
                  </div>
                </div>
                {/* NestJS */}
                <div className="col-lg-2 col-md-3 col-sm-4 col-6">
                  <div className="item">
                    <img
                      className="icon"
                      src={nest}
                      alt="NestJS Skill"
                      loading="lazy"
                      decoding="async"
                      style={{
                        width: "30%",
                        height: "30%",
                        marginBottom: 10,
                        marginTop: 20,
                      }}
                    />
                    <h6>Nest js </h6>
                  </div>
                </div>
                {/* GitHub */}
                <div className="col-lg-2 col-md-3 col-sm-4 col-6">
                  <div className="item">
                    <img
                      className="icon"
                      src={git}
                      alt="GitHub Skill"
                      loading="lazy"
                      decoding="async"
                      style={{
                        width: "30%",
                        height: "30%",
                        marginBottom: 10,
                        marginTop: 20,
                      }}
                    />
                    <h6>Github </h6>
                  </div>
                </div>
                {/* NextJS */}
                <div className="col-lg-2 col-md-3 col-sm-4 col-6">
                  <div className="item">
                    <img
                      className="icon"
                      src={next}
                      alt="NextJS Skill"
                      loading="lazy"
                      decoding="async"
                      style={{
                        width: "30%",
                        height: "30%",
                        marginBottom: 10,
                        marginTop: 20,
                        backgroundColor: "white",
                        borderRadius: "50%",
                        padding: 5,
                      }}
                    />
                    <h6>Next js </h6>
                  </div>
                </div>
                {/* Postman */}
                <div className="col-lg-2 col-md-3 col-sm-4 col-6">
                  <div className="item">
                    <img
                      className="icon"
                      src={pm}
                      alt="Postman Skill"
                      loading="lazy"
                      decoding="async"
                      style={{
                        width: "30%",
                        height: "30%",
                        marginBottom: 10,
                        marginTop: 20,
                      }}
                    />
                    <h6>Postman </h6>
                  </div>
                </div>
                {/* Android */}
                <div className="col-lg-2 col-md-3 col-sm-4 col-6">
                  <div className="item">
                    <img
                      className="icon"
                      src={android}
                      alt="Android Skill"
                      loading="lazy"
                      decoding="async"
                      style={{
                        width: "30%",
                        height: "30%",
                        marginBottom: 10,
                        marginTop: 20,
                      }}
                    />
                    <h6>Android </h6>
                  </div>
                </div>
                {/* iOS */}
                <div className="col-lg-2 col-md-3 col-sm-4 col-6">
                  <div className="item">
                    <img
                      className="icon"
                      src={ios}
                      alt="iOS Skill"
                      loading="lazy"
                      decoding="async"
                      style={{
                        width: "30%",
                        height: "30%",
                        marginBottom: 10,
                        marginTop: 20,
                      }}
                    />
                    <h6>IOS </h6>
                  </div>
                </div>
                {/* Python */}
                <div className="col-lg-2 col-md-3 col-sm-4 col-6">
                  <div className="item">
                    <img
                      className="icon"
                      src={py}
                      alt="Python Skill"
                      loading="lazy"
                      decoding="async"
                      style={{
                        width: "30%",
                        height: "30%",
                        marginBottom: 10,
                        marginTop: 20,
                      }}
                    />
                    <h6>Python </h6>
                  </div>
                </div>
                {/* Jira */}
                <div className="col-lg-2 col-md-3 col-sm-4 col-6">
                  <div className="item">
                    <img
                      className="icon"
                      src={jira}
                      alt="Jira Skill"
                      loading="lazy"
                      decoding="async"
                      style={{
                        width: "30%",
                        height: "30%",
                        marginBottom: 10,
                        marginTop: 20,
                      }}
                    />
                    <h6>Jira </h6>
                  </div>
                </div>
                {/* Node.js */}
                <div className="col-lg-2 col-md-3 col-sm-4 col-6">
                  <div className="item">
                    <img
                      className="icon"
                      src={node}
                      alt="Node.js Skill"
                      loading="lazy"
                      decoding="async"
                      style={{
                        width: "30%",
                        height: "30%",
                        marginBottom: 10,
                        marginTop: 20,
                      }}
                    />
                    <h6>Node js </h6>
                  </div>
                </div>
                {/* Firebase */}
                <div className="col-lg-2 col-md-3 col-sm-4 col-6">
                  <div className="item">
                    <img
                      className="icon"
                      src={firebase}
                      alt="Firebase Skill"
                      loading="lazy"
                      decoding="async"
                      style={{
                        width: "22%",
                        height: "22%",
                        marginBottom: 10,
                        marginTop: 20,
                      }}
                    />
                    <h6>Firebase </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <img className="background-image-left" src={colorSharp} alt="Image" loading="lazy" decoding="async" /> */}
    </section>
  );
};